import { useEffect, useState } from "react";
import { getMaquinasJustificacion } from "../services/justificacion";

export const useMaquinasJustificacion = (fecha, id_area_operacion, forceRefresh) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!fecha) {
            return;
        }
        setLoading(true);
        setError(null);
        getMaquinasJustificacion(fecha, id_area_operacion)
            .then(maquinas => {
                setData(maquinas.data);
                setLoading(false);
            })
            .catch(err => {
                setError(err);
                setLoading(false);
                console.log(err);
            });
    }, [fecha, forceRefresh]);

    return { data, loading, error };
}

    
    
